import PropTypes from "prop-types";
import TestPrice from "@/src/components/common/test-search/testPrice";
import Iconify from "@/src/components/iconify";
import IconCode from "@/src/lib/iconCode";

import Link from "next/link";
import CustomChip from "@/src/lib/ui/customChip";
import CustomTooltip from "@/src/lib/ui/customTooltip";
import TatByCity from "@/src/components/common/tat/tatByCity";

const TestCard = ({
    item,
    isSpacing = false,
    bookButtonText = "Read More",
    knowMoreButtonText = "Know More",
}) => {
    // const handleBookNow = () => { };

    // const handleKnowMore = () => {
    //   console.log("Know More button clicked!");
    // };

    // Function to truncate text after 26 characters and add ellipsis
    const truncateText = (text, maxLength = 29) => {
        if (!text) return "";
        return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    };
    return (
        <div className={isSpacing ? "md:mx-3 mx-1 py-3" : ""}>
            {/* Allow the link to be customizable */}
            {/* <Link href={`/test/${item?.urlSlug}`}> */}
            <div className="group relative h-full">
                <div className="bg-white md:p-3 h-full p-2 border border-solid border-gray-300 hover:border-primary shadow-md rounded-lg">
                    {/* Header section: Title and Category */}
                    <div className="flex flex-row items-start justify-between gap-2 pb-2">
                        <div>
                            <CustomTooltip
                                title={item?.configProductCard?.productName}
                            >
                                <h3 className="text-base text-black font-bold leading-5 mb-0.5">
                                    {truncateText(item?.configProductCard?.productName)}
                                </h3>
                            </CustomTooltip>

                            <p className="text-xs text-gray-600 mb-4">
                                {/* {item?.configProductCard?.categoryName || item?.configProductCard?.categoryType} */}
                                {item?.configProductCard?.categoryType == "scan"
                                    ? "Radiology"
                                    : item?.configProductCard?.categoryType ==
                                      "lab"
                                    ? "Pathology"
                                    : "Packages"}
                            </p>
                        </div>

                        <CustomChip
                            size="small"
                            label={
                                item?.configProductCard?.categoryName ||
                                item?.configProductCard?.category
                            }
                            variant="outlined"
                            className="text-xs"
                            color="error"
                        />
                    </div>

                    {/* Information section: Inclusions and Report TAT */}
                    <div>
                        <div className="flex flex-row items-center justify-between gap-2 pb-2">
                            {item?.configProductCard?.inclusions && (
                                <>
                                    <div className="flex flex-row items-center gap-1">
                                        <Iconify
                                            icon={IconCode.paramter}
                                            width="30px"
                                            color="gray"
                                        />
                                        <div className="flex flex-col items-start">
                                            {" "}
                                            {/* Use 'flex-start' for left alignment */}
                                            <p className="text-sm font-semibold text-gray-600">
                                                {
                                                    item?.configProductCard
                                                        ?.inclusions
                                                        .inclusionCount
                                                }{" "}
                                                {
                                                    item?.configProductCard
                                                        ?.inclusions
                                                        .inclusionType
                                                }
                                                {item?.configProductCard
                                                    ?.inclusions
                                                    .inclusionCount > 1
                                                    ? "s"
                                                    : ""}
                                            </p>
                                            <p className="text-xs text-gray-600">
                                                Included
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex flex-row items-center gap-1">
                                        <Iconify
                                            icon={IconCode.reportTat}
                                            width="30px"
                                            color="gray"
                                        />
                                        <div className="flex flex-col items-start">
                                            <p className="text-sm font-semibold text-gray-600 leading-3 pb-1">
                                                Report TAT
                                            </p>
                                             <TatByCity
                                                tat={item?.configProductCard?.tatByCityId}
                                                className="text-xs text-gray-600"
                                            /> 
                                             {/* <p className="text-xs text-gray-600">
                                                {`${
                                                    item?.configProductCard
                                                        ?.inclusions
                                                        ?.defaultTat ||
                                                    "1-5 day(s)"
                                                }*`}
                                            </p>  */}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        {/* Description */}
                        {/* <p
              component="p"
              className="text-xs text-gray-600 leading-4"
            >
              {item?.configProductCard?.healthPackageDec}
            </p> */}

                        {/* Pricing */}
                        <div className="py-4">
                            <div className="flex flex-row justify-between">
                                <TestPrice
                                    price={item?.configProductCard?.cityPrice}
                                    minPrice={item?.configProductCard?.minPrice}
                                    maxPrice={item?.configProductCard?.maxPrice}
                                    textColor={"text-black"}
                                />
                                <div>
                                    <Link
                                        style={{ flex: 1 }}
                                        className="bg-primary text-white px-4 py-2 rounded-xs text-sm hover:bg-primary/80 transition-all duration-300 font-medium"
                                        href={`/test/${item?.configProductCard?.urlSlug}`}
                                    >
                                        {bookButtonText}
                                    </Link>
                                </div>
                            </div>
                        </div>

                        {/* Action buttons */}
                    </div>
                </div>
            </div>
            {/* </Link> */}
        </div>
    );
};

TestCard.propTypes = {
    item: PropTypes.shape({
        urlSlug: PropTypes.string.isRequired,
        productName: PropTypes.string.isRequired,
        categoryName: PropTypes.string,
        categoryType: PropTypes.string,
        inclusions: PropTypes.shape({
            inclusion_count: PropTypes.number,
            inclusion_type: PropTypes.string,
        }),
        cityPrice: PropTypes.object,
        maxPrice: PropTypes.number,
        minPrice: PropTypes.number,
    }).isRequired,
    isSpacing: PropTypes.bool,
    onBookNow: PropTypes.func,
    onKnowMore: PropTypes.func,
    bookButtonText: PropTypes.string,
    knowMoreButtonText: PropTypes.string,
};

export default TestCard;
